import { isEmpty, isNumber } from 'lodash'

const defaulted = (value, fallback=' ') =>
{
	if ( !isEmpty(value) || isNumber(value) )
	{
		return value
	}

	return fallback
}

export default defaulted